import { jsx as u } from "react/jsx-runtime";
import * as c from "react";
import { b as k, a as ae, c as y } from "../index-eoE_jzLb.js";
import { u as T, S as ce } from "../index-DoOsnuB6.js";
import { P as S, c as ue } from "../index-D8UDu4KA.js";
import { R as ie, c as j, a as G, D as le, C as de, A as fe, P as pe } from "../index-C18TsXFG.js";
import { u as ve } from "../index-n3ZmtxN0.js";
import { P as $ } from "../index-CRtCLpV2.js";
import { h as me, R as ge } from "../index-B4nkmsKV.js";
import { c as V } from "../clsx-OuTLNxxd.js";
import { B as he } from "../Button-Cw7ErxOW.js";
import '../Popover.css';var _ = 0;
function Pe() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? D()), document.body.insertAdjacentElement("beforeend", e[1] ?? D()), _++, () => {
      _ === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((o) => o.remove()), _--;
    };
  }, []);
}
function D() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var N = "focusScope.autoFocusOnMount", x = "focusScope.autoFocusOnUnmount", L = { bubbles: !1, cancelable: !0 }, Ce = "FocusScope", W = c.forwardRef((e, o) => {
  const {
    loop: t = !1,
    trapped: n = !1,
    onMountAutoFocus: s,
    onUnmountAutoFocus: a,
    ...i
  } = e, [r, v] = c.useState(null), d = k(s), P = k(a), C = c.useRef(null), g = T(o, (l) => v(l)), f = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (n) {
      let l = function(h) {
        if (f.paused || !r) return;
        const m = h.target;
        r.contains(m) ? C.current = m : E(C.current, { select: !0 });
      }, R = function(h) {
        if (f.paused || !r) return;
        const m = h.relatedTarget;
        m !== null && (r.contains(m) || E(C.current, { select: !0 }));
      }, p = function(h) {
        if (document.activeElement === document.body)
          for (const M of h)
            M.removedNodes.length > 0 && E(r);
      };
      document.addEventListener("focusin", l), document.addEventListener("focusout", R);
      const A = new MutationObserver(p);
      return r && A.observe(r, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", l), document.removeEventListener("focusout", R), A.disconnect();
      };
    }
  }, [n, r, f.paused]), c.useEffect(() => {
    if (r) {
      K.add(f);
      const l = document.activeElement;
      if (!r.contains(l)) {
        const p = new CustomEvent(N, L);
        r.addEventListener(N, d), r.dispatchEvent(p), p.defaultPrevented || (Ee(ye(q(r)), { select: !0 }), document.activeElement === l && E(r));
      }
      return () => {
        r.removeEventListener(N, d), setTimeout(() => {
          const p = new CustomEvent(x, L);
          r.addEventListener(x, P), r.dispatchEvent(p), p.defaultPrevented || E(l ?? document.body, { select: !0 }), r.removeEventListener(x, P), K.remove(f);
        }, 0);
      };
    }
  }, [r, d, P, f]);
  const se = c.useCallback(
    (l) => {
      if (!t && !n || f.paused) return;
      const R = l.key === "Tab" && !l.altKey && !l.ctrlKey && !l.metaKey, p = document.activeElement;
      if (R && p) {
        const A = l.currentTarget, [h, m] = be(A);
        h && m ? !l.shiftKey && p === m ? (l.preventDefault(), t && E(h, { select: !0 })) : l.shiftKey && p === h && (l.preventDefault(), t && E(m, { select: !0 })) : p === A && l.preventDefault();
      }
    },
    [t, n, f.paused]
  );
  return /* @__PURE__ */ u(S.div, { tabIndex: -1, ...i, ref: g, onKeyDown: se });
});
W.displayName = Ce;
function Ee(e, { select: o = !1 } = {}) {
  const t = document.activeElement;
  for (const n of e)
    if (E(n, { select: o }), document.activeElement !== t) return;
}
function be(e) {
  const o = q(e), t = U(o, e), n = U(o.reverse(), e);
  return [t, n];
}
function q(e) {
  const o = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const s = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || s ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) o.push(t.currentNode);
  return o;
}
function U(e, o) {
  for (const t of e)
    if (!Oe(t, { upTo: o })) return t;
}
function Oe(e, { upTo: o }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (o !== void 0 && e === o) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Re(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function E(e, { select: o = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== t && Re(e) && o && e.select();
  }
}
var K = Ae();
function Ae() {
  let e = [];
  return {
    add(o) {
      const t = e[0];
      o !== t && (t == null || t.pause()), e = H(e, o), e.unshift(o);
    },
    remove(o) {
      var t;
      e = H(e, o), (t = e[0]) == null || t.resume();
    }
  };
}
function H(e, o) {
  const t = [...e], n = t.indexOf(o);
  return n !== -1 && t.splice(n, 1), t;
}
function ye(e) {
  return e.filter((o) => o.tagName !== "A");
}
var w = "Popover", [B] = ue(w, [
  j
]), F = j(), [Fe, b] = B(w), Z = (e) => {
  const {
    __scopePopover: o,
    children: t,
    open: n,
    defaultOpen: s,
    onOpenChange: a,
    modal: i = !1
  } = e, r = F(o), v = c.useRef(null), [d, P] = c.useState(!1), [C = !1, g] = ae({
    prop: n,
    defaultProp: s,
    onChange: a
  });
  return /* @__PURE__ */ u(ie, { ...r, children: /* @__PURE__ */ u(
    Fe,
    {
      scope: o,
      contentId: ve(),
      triggerRef: v,
      open: C,
      onOpenChange: g,
      onOpenToggle: c.useCallback(() => g((f) => !f), [g]),
      hasCustomAnchor: d,
      onCustomAnchorAdd: c.useCallback(() => P(!0), []),
      onCustomAnchorRemove: c.useCallback(() => P(!1), []),
      modal: i,
      children: t
    }
  ) });
};
Z.displayName = w;
var z = "PopoverAnchor", _e = c.forwardRef(
  (e, o) => {
    const { __scopePopover: t, ...n } = e, s = b(z, t), a = F(t), { onCustomAnchorAdd: i, onCustomAnchorRemove: r } = s;
    return c.useEffect(() => (i(), () => r()), [i, r]), /* @__PURE__ */ u(G, { ...a, ...n, ref: o });
  }
);
_e.displayName = z;
var J = "PopoverTrigger", Q = c.forwardRef(
  (e, o) => {
    const { __scopePopover: t, ...n } = e, s = b(J, t), a = F(t), i = T(o, s.triggerRef), r = /* @__PURE__ */ u(
      S.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": s.open,
        "aria-controls": s.contentId,
        "data-state": oe(s.open),
        ...n,
        ref: i,
        onClick: y(e.onClick, s.onOpenToggle)
      }
    );
    return s.hasCustomAnchor ? r : /* @__PURE__ */ u(G, { asChild: !0, ...a, children: r });
  }
);
Q.displayName = J;
var I = "PopoverPortal", [Ne, xe] = B(I, {
  forceMount: void 0
}), X = (e) => {
  const { __scopePopover: o, forceMount: t, children: n, container: s } = e, a = b(I, o);
  return /* @__PURE__ */ u(Ne, { scope: o, forceMount: t, children: /* @__PURE__ */ u($, { present: t || a.open, children: /* @__PURE__ */ u(pe, { asChild: !0, container: s, children: n }) }) });
};
X.displayName = I;
var O = "PopoverContent", Y = c.forwardRef(
  (e, o) => {
    const t = xe(O, e.__scopePopover), { forceMount: n = t.forceMount, ...s } = e, a = b(O, e.__scopePopover);
    return /* @__PURE__ */ u($, { present: n || a.open, children: a.modal ? /* @__PURE__ */ u(Te, { ...s, ref: o }) : /* @__PURE__ */ u(Se, { ...s, ref: o }) });
  }
);
Y.displayName = O;
var Te = c.forwardRef(
  (e, o) => {
    const t = b(O, e.__scopePopover), n = c.useRef(null), s = T(o, n), a = c.useRef(!1);
    return c.useEffect(() => {
      const i = n.current;
      if (i) return me(i);
    }, []), /* @__PURE__ */ u(ge, { as: ce, allowPinchZoom: !0, children: /* @__PURE__ */ u(
      ee,
      {
        ...e,
        ref: s,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: y(e.onCloseAutoFocus, (i) => {
          var r;
          i.preventDefault(), a.current || (r = t.triggerRef.current) == null || r.focus();
        }),
        onPointerDownOutside: y(
          e.onPointerDownOutside,
          (i) => {
            const r = i.detail.originalEvent, v = r.button === 0 && r.ctrlKey === !0, d = r.button === 2 || v;
            a.current = d;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: y(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Se = c.forwardRef(
  (e, o) => {
    const t = b(O, e.__scopePopover), n = c.useRef(!1), s = c.useRef(!1);
    return /* @__PURE__ */ u(
      ee,
      {
        ...e,
        ref: o,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, r;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (n.current || (r = t.triggerRef.current) == null || r.focus(), a.preventDefault()), n.current = !1, s.current = !1;
        },
        onInteractOutside: (a) => {
          var v, d;
          (v = e.onInteractOutside) == null || v.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (s.current = !0));
          const i = a.target;
          ((d = t.triggerRef.current) == null ? void 0 : d.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && s.current && a.preventDefault();
        }
      }
    );
  }
), ee = c.forwardRef(
  (e, o) => {
    const {
      __scopePopover: t,
      trapFocus: n,
      onOpenAutoFocus: s,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: r,
      onPointerDownOutside: v,
      onFocusOutside: d,
      onInteractOutside: P,
      ...C
    } = e, g = b(O, t), f = F(t);
    return Pe(), /* @__PURE__ */ u(
      W,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: s,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ u(
          le,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: P,
            onEscapeKeyDown: r,
            onPointerDownOutside: v,
            onFocusOutside: d,
            onDismiss: () => g.onOpenChange(!1),
            children: /* @__PURE__ */ u(
              de,
              {
                "data-state": oe(g.open),
                role: "dialog",
                id: g.contentId,
                ...f,
                ...C,
                ref: o,
                style: {
                  ...C.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), te = "PopoverClose", we = c.forwardRef(
  (e, o) => {
    const { __scopePopover: t, ...n } = e, s = b(te, t);
    return /* @__PURE__ */ u(
      S.button,
      {
        type: "button",
        ...n,
        ref: o,
        onClick: y(e.onClick, () => s.onOpenChange(!1))
      }
    );
  }
);
we.displayName = te;
var Ie = "PopoverArrow", Me = c.forwardRef(
  (e, o) => {
    const { __scopePopover: t, ...n } = e, s = F(t);
    return /* @__PURE__ */ u(fe, { ...s, ...n, ref: o });
  }
);
Me.displayName = Ie;
function oe(e) {
  return e ? "open" : "closed";
}
var ke = Z, De = Q, Le = X, Ue = Y;
const Ke = "_popoverContent_19bmj_1", He = "_trigger_19bmj_13", ne = {
  popoverContent: Ke,
  trigger: He
}, re = ({ children: e, ...o }) => /* @__PURE__ */ u(ke, { ...o, children: e }), je = ({
  children: e,
  className: o,
  ...t
}) => /* @__PURE__ */ u(De, { asChild: !0, "data-testid": "popover-trigger", ...t, children: /* @__PURE__ */ u(he, { className: V(ne.trigger, o), variant: "ghost", children: e }) }), Ge = ({
  children: e,
  className: o,
  ...t
}) => /* @__PURE__ */ u(Le, { children: /* @__PURE__ */ u(
  Ue,
  {
    className: V(ne.popoverContent, o),
    collisionPadding: 8,
    "data-cxy-name": "popover",
    "data-testid": "popover-content",
    sideOffset: 5,
    ...t,
    children: e
  }
) });
re.Trigger = je;
re.Content = Ge;
export {
  re as Popover
};
